import { Theme, useMediaQuery } from '@mui/material';
import { CoreBox, CoreTypography } from '@youscience/core';

import { ROUTES } from '@constants/ROUTES';
import { areasDescriptionMap } from '@common-types';
import { AreaOfStudyCard } from '@components/AreaOfStudyCard';

import ChevronRightIcon from '@images/chevron-right.svg?react';

import {
  sxStyles,
  StyledAreasOfStudyInner,
  StyledAreaCardsContainer,
  StyledExploreMoreLink,
} from './AreasSection.styles';

interface AreasSectionProps {
  areasList: number[];
}

export const AreasSection = (props: AreasSectionProps) => {
  const { areasList } = props;

  const isMobileScreen = useMediaQuery((theme: Theme) => theme.breakpoints.down('xs'));

  const areasOfStudy = isMobileScreen ? areasList.slice(0, 5) : areasList.slice(0, 15);

  if (!areasOfStudy.length) return null;

  return (
    <CoreBox sx={sxStyles.areasOfStudyBg}>
      <StyledAreasOfStudyInner>
        <CoreBox sx={sxStyles.titleWrap}>
          <CoreTypography variant="h3" component="h2">
            Explore an area of study
          </CoreTypography>

          <StyledExploreMoreLink data-testid="showMoreAreas" to={ROUTES.MAJORS}>
            Explore more
            <ChevronRightIcon fill="#FFFFFF" />
          </StyledExploreMoreLink>
        </CoreBox>

        <StyledAreaCardsContainer>
          {areasOfStudy.map((area) => (
            <AreaOfStudyCard
              key={area}
              cipTitle={areasDescriptionMap.get(area)?.cipTitle as string}
              currentCipCode={area}
            />
          ))}
        </StyledAreaCardsContainer>
      </StyledAreasOfStudyInner>
    </CoreBox>
  );
};
